import {Component, Input} from '@angular/core';
import {Sessao} from '../../../../shared/model/sessao/sessao.model';
import {CelularMaskPipe} from '../../../../shared/pipe/celular-mask.pipe';

@Component({
  selector: 'app-card-sessao-linha-inferior',
  standalone: true,
  imports: [
    CelularMaskPipe
  ],
  templateUrl: './card-sessao-linha-inferior.component.html',
  styleUrl: './card-sessao-linha-inferior.component.css'
})
export class CardSessaoLinhaInferiorComponent {

  @Input() sessao?: Sessao

}
